import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import getPersonalisedProduct from 'store/product/selector/getPersonalisedProduct';
import cn from 'classnames';
import styles from './PersonalisedProductDetails.module.scss';
import Accordion from '../../Common/Accordion/Accordion';

interface OwnProps {
  theme?: string;
}

const PersonalisedProductDetails: FC<OwnProps> = ({ theme }) => {
  const { t } = useTranslation();
  const product = useSelector(getPersonalisedProduct);
  return (
    <div className={cn(styles.productDetailsContent, styles[`theme-${theme}`])}>
      {product?.description && (
        <Accordion theme={theme} title={t('txt_amp_product_details_title')} titleClassName={styles.title}>
          <div className={styles.content}>
            <span dangerouslySetInnerHTML={{ __html: product?.details || '' }} />
          </div>
        </Accordion>
      )}
    </div>
  );
};

export default PersonalisedProductDetails;
